/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count the syllables in any word, sentence or poem. Type or paste your text and the syllable, word and character counts update instantly — with a per-line breakdown.`)
};

const es_syl_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta las sílabas de cualquier palabra, frase o poema. Escribe o pega tu texto y el recuento de sílabas, palabras y caracteres se actualiza al instante — con un desglose por línea.`)
};

const de_syl_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zähle die Silben in jedem Wort, Satz oder Gedicht. Gib deinen Text ein oder füge ihn ein, und die Silben-, Wort- und Zeichenzahl wird sofort aktualisiert — inklusive Aufschlüsselung pro Zeile.`)
};

const nl_syl_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel de lettergrepen in elk woord, elke zin of elk gedicht. Typ of plak je tekst en het aantal lettergrepen, woorden en tekens wordt direct bijgewerkt — met een uitsplitsing per regel.`)
};

const fr_syl_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptez les syllabes de n'importe quel mot, phrase ou poème. Saisissez ou collez votre texte et le nombre de syllabes, de mots et de caractères se met à jour instantanément — avec un détail ligne par ligne.`)
};

const it_syl_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta le sillabe in qualsiasi parola, frase o poesia. Digita o incolla il tuo testo e il conteggio di sillabe, parole e caratteri si aggiorna all'istante — con un dettaglio riga per riga.`)
};

const pt_br2_syl_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte as sílabas em qualquer palavra, frase ou poema. Digite ou cole seu texto e as contagens de sílabas, palavras e caracteres são atualizadas instantaneamente — com um detalhamento linha por linha.`)
};

const pt_syl_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte as sílabas em qualquer palavra, frase ou poema. Escreva ou cole o seu texto e as contagens de sílabas, palavras e caracteres atualizam-se instantaneamente — com uma discriminação linha a linha.`)
};

const ja_syl_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語、文章、詩など、あらゆるテキストの音節数をカウントできます。テキストを入力または貼り付けるだけで、音節数・単語数・文字数がすぐに更新され、行ごとの内訳も確認できます。`)
};

const zh_syl_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`统计任意单词、句子或诗歌中的音节数。输入或粘贴文本后，音节数、单词数和字符数会即时更新，并提供逐行明细。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_hub_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_hub_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_hub_intro", locale)
	if (locale === "en") return en_syl_hub_intro(inputs)
	if (locale === "es") return es_syl_hub_intro(inputs)
	if (locale === "de") return de_syl_hub_intro(inputs)
	if (locale === "nl") return nl_syl_hub_intro(inputs)
	if (locale === "fr") return fr_syl_hub_intro(inputs)
	if (locale === "it") return it_syl_hub_intro(inputs)
	if (locale === "pt-BR") return pt_br2_syl_hub_intro(inputs)
	if (locale === "pt") return pt_syl_hub_intro(inputs)
	if (locale === "ja") return ja_syl_hub_intro(inputs)
	return zh_syl_hub_intro(inputs)
};